module.exports = __webpack_public_path__ + "img/bn0701.b9a82fcb.png";